"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURE_BOX_POSITION = exports.PROCESS_ITEM_POSITION = exports.SLOGAN_TYPE = exports.TEAM_CARD_POSITION = void 0;
exports.TEAM_CARD_POSITION = ['center', 'left'];
exports.SLOGAN_TYPE = ['outlined', 'solid'];
exports.PROCESS_ITEM_POSITION = ['center', 'left'];
exports.FEATURE_BOX_POSITION = ['center', 'left'];